module.exports = __webpack_public_path__ + "3c6c5dbe54c5c2af8734d3db3bdfeb9f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/david-luecke.jpg
 ** module id = 408
 ** module chunks = 0
 **/